import type { Transaction } from '@api/hooks/types/getTransactions';
import { EmptyState } from '@components/EmptyState';
import { useBankProfile } from '@contexts/BankProfileContext';
import { type ColumnProps, OperationIcon, Table } from '@gurupay/gp-ui-library';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Role } from 'types/roles';

import { ApprovalsRenderers } from './ApprovalsRenderers';

interface ApprovalsTableProps {
	transactions: Transaction[];
	isLoading: boolean;
}

export const ApprovalsTable = ({ transactions, isLoading }: ApprovalsTableProps) => {
	const { t } = useTranslation('', { keyPrefix: 'dashboard.approvals' });
	const navigate = useNavigate();
	const columns: ColumnProps[] = [{ label: '', key: 'transactionInfo', align: 'left' }];
	const { selectedProfile } = useBankProfile();

	const handleRowClick = ({ id }: Transaction) => {
		navigate(`/payments/${id}`);
	};

	if (!isLoading && !transactions.length) {
		return (
			<EmptyState
				buttonProps={
					selectedProfile?.role && ![Role.VIEW, Role.SIGN].includes(selectedProfile?.role)
						? {
								children: t('createPayment'),
								href: '/payments/sepa',
							}
						: undefined
				}
				icon={<OperationIcon />}
				title={t('noApprovals')}
			/>
		);
	}

	return (
		<Table
			className="p-space-8 [&_td]:p-space-8 [&_tr:hover_.approval-icon]:bg-neutral-100"
			columns={columns}
			isLoading={isLoading}
			onRowClick={handleRowClick}
			renders={ApprovalsRenderers}
			rows={transactions}
		/>
	);
};
